/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Offline_SectionInputs */

const en_voice_manager_offline_section = /** @type {(inputs: Voice_Manager_Offline_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline Voices`)
};

const fr_voice_manager_offline_section = /** @type {(inputs: Voice_Manager_Offline_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voix hors ligne`)
};

const de_voice_manager_offline_section = /** @type {(inputs: Voice_Manager_Offline_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline-Stimmen`)
};

const it_voice_manager_offline_section = /** @type {(inputs: Voice_Manager_Offline_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voci offline`)
};

const ru_voice_manager_offline_section = /** @type {(inputs: Voice_Manager_Offline_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Голоса вне сети`)
};

const es_voice_manager_offline_section = /** @type {(inputs: Voice_Manager_Offline_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voces sin conexión`)
};

const zh_cn2_voice_manager_offline_section = /** @type {(inputs: Voice_Manager_Offline_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线声音`)
};

const ja_voice_manager_offline_section = /** @type {(inputs: Voice_Manager_Offline_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフライン音声`)
};

const hi_voice_manager_offline_section = /** @type {(inputs: Voice_Manager_Offline_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़लाइन आवाज़ें`)
};

const pt_pt2_voice_manager_offline_section = /** @type {(inputs: Voice_Manager_Offline_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vozes offline`)
};

/**
* | output |
* | --- |
* | "Offline Voices" |
*
* @param {Voice_Manager_Offline_SectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_offline_section = /** @type {((inputs?: Voice_Manager_Offline_SectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Offline_SectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_offline_section(inputs)
	if (locale === "de") return de_voice_manager_offline_section(inputs)
	if (locale === "it") return it_voice_manager_offline_section(inputs)
	if (locale === "ru") return ru_voice_manager_offline_section(inputs)
	if (locale === "es") return es_voice_manager_offline_section(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_offline_section(inputs)
	if (locale === "ja") return ja_voice_manager_offline_section(inputs)
	if (locale === "hi") return hi_voice_manager_offline_section(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_offline_section(inputs)
	return en_voice_manager_offline_section(inputs)
});